import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from './contexts/LanguageContext';
import './PersonalProfilePage.css';

const PersonalProfilePage = () => {
  const navigate = useNavigate();
  const { t, language, changeLanguage } = useLanguage();
  const [showFirstTask, setShowFirstTask] = useState(true);
  const [showSecondTask, setShowSecondTask] = useState(false);
  const [taskAnimation, setTaskAnimation] = useState(true);
  const [showDevelopingModal, setShowDevelopingModal] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userData, setUserData] = useState(null);

  // 检查用户登录状态
  useEffect(() => {
    const storedUser = localStorage.getItem('talktastic_user');
    if (storedUser) {
      try {
        const user = JSON.parse(storedUser);
        if (user && user.isRegistered) {
          setIsLoggedIn(true);
          setUserData(user);
        } else {
          // 未登录，重定向到登录页面
          navigate('/login');
        }
      } catch (error) {
        console.error('读取用户信息失败:', error);
        navigate('/login');
      }
    } else {
      // 未登录，重定向到登录页面
      navigate('/login');
    }
  }, [navigate]);

  // 点击档案任务按钮，显示任务弹窗
  const handleShowProfileTask = () => {
    setShowFirstTask(true);
  };

  // 点击确定按钮的处理函数
  const handleConfirm = () => {
    setShowFirstTask(false);
    setShowSecondTask(true);
  };

  // 点击关闭按钮的处理函数
  const handleClose = () => {
    setShowSecondTask(false);
    navigate('/simulation-training'); // 跳转到模拟训练页面
  };

  // 关闭开发中提示框
  const handleCloseDevelopingModal = () => {
    setShowDevelopingModal(false);
    navigate('/'); // 导航回首页
  };

  // 导航回主页
  const handleBackToHome = () => {
    navigate('/');
  };

  // 处理登出
  const handleLogout = () => {
    localStorage.removeItem('talktastic_user');
    navigate('/login');
  };

  return (
    <div className="profile-page-container">
      {/* 完全移除导航栏 */}

      {/* 主要内容区域 */}
      <div className="profile-content">
        {/* 添加语言切换按钮 */}
        <div className="language-switcher-container" style={{ 
          position: 'absolute', 
          top: '20px', 
          right: '20px',
          zIndex: 100
        }}>
          <button 
            className="language-toggle-btn" 
            onClick={() => {
              const newLang = language === 'en' ? 'zh' : 'en';
              changeLanguage(newLang);
            }}
            style={{
              padding: '5px 10px',
              borderRadius: '4px',
              border: '1px solid #ccc',
              background: '#fff',
              cursor: 'pointer'
            }}
          >
            {language === 'en' ? '中文' : 'English'}
          </button>
        </div>
        
        {/* 黄瓜星球标题 */}
        <div className="planet-header">
          <div className="planet-title">
            <span className="id-icon">🪪</span>
            <h2>
              {isLoggedIn 
                ? (language === 'en' ? `Pickle Planet ${userData?.email?.split('@')[0] || 'User'}` : `黄瓜星球${userData?.email?.split('@')[0] || '用户'}`) 
                : (language === 'en' ? 'Pickle Planet nobody' : '黄瓜星球nobody')}
            </h2>
          </div>
          <img src={process.env.PUBLIC_URL + '/images/suanhuanggua.png'} alt={language === 'en' ? 'Pickle Planet' : '酸黄瓜星球'} className="planet-image" />
        </div>

        {/* 第一个任务框 */}
        {showFirstTask && (
          <div className={`task-modal ${taskAnimation ? 'slide-in' : ''}`}>
            <div className="task-content">
              <h3>{t('ielts_task_introduction')}</h3>
              <p>{t('immersive_task_intro')}</p>
              <p>{t('magic_code')}</p>
              <p>{t('personality_action')}</p>
              <p>{t('gamified_profile')}</p>
              <p className="task-highlight">{t('click_confirm')}</p>
              <div className="task-buttons">
                <button className="task-confirm-btn" onClick={handleConfirm}>
                  {language === 'en' ? 'Confirm' : '确定'}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* 第二个任务框 */}
        {showSecondTask && (
          <div className={`task-modal ${taskAnimation ? 'slide-in' : ''}`}>
            <div className="task-content">
              <h3>{t('immersive_game_welcome')}</h3>
              <p>{t('pickle_planet_intro')}</p>
              <div className="task-buttons">
                <button className="task-close-btn" onClick={handleClose}>
                  {language === 'en' ? 'Close' : '关闭'}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* 开发中提示框 */}
        {showDevelopingModal && (
          <div className="report-modal-overlay">
            <div className="optimization-modal">
              <h3 className="modal-title">{t('personal_profile')}</h3>
              <div className="modal-content">
                <div className="modal-icon">🚧</div>
                <h2>{language === 'en' ? 'Under Development' : '功能开发中'}</h2>
                <p>{language === 'en' ? 'This feature is currently under development. Please check back later.' : '该功能正在开发中，请稍后再试。'}</p>
              </div>
              <div className="modal-actions">
                <button onClick={handleCloseDevelopingModal} className="primary-btn">
                  {t('return_home')}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* 个人档案内容区域 */}
        <div className="profile-form-area">
          {/* AI 对话练习入口 */}
          <div className="pickle-date-entrance">
            <h3>🤖 AI 英语对话练习</h3>
            <p>与 AI 进行英语口语练习，提升表达能力！</p>
            <p>系统会推荐更好的表达方式，帮助你积累词汇。</p>
            <div className="entrance-buttons">
              <button 
                className="start-date-btn"
                onClick={() => navigate('/simulation-training')}
              >
                🚀 开始练习
              </button>
              <button 
                className="profile-task-btn"
                onClick={handleShowProfileTask}
              >
                📋 查看档案任务
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PersonalProfilePage; 